import { AssetPrice as OldAssetPrice } from "@models/tradable/split/asset_price";

import { PriceChange } from "./price-change";
import { IndexAllocation, IndexAllocationAdapter } from "./index-allocation";

export interface TradablePrice {
	readonly id: string;
	readonly circulatingSupply: number;
	readonly price: number;
	priceAmountChanges: PriceChange;
	pricePercentageChanges: PriceChange;
	indexAssets?: IndexAllocation[];
}

export class TradablePriceAdapter {
	private indexAllocationAdapter = new IndexAllocationAdapter();

	public adapt(price: OldAssetPrice): TradablePrice {
		return {
			id: price.getId(),
			circulatingSupply: price.getCirculatingSupply(),
			price: price.getPrice(),
			priceAmountChanges: {
				day: price.getChange24hAmount(),
				week: price.getChange1wAmount(),
				month: price.getChange1mAmount(),
				year: price.getChange1yAmount(),
				six_months: price.getChange6mAmount(),
				five_years: price.getChange5yAmount()
			},
			pricePercentageChanges: {
				day: price.getChange24h(),
				week: price.getChange1w(),
				month: price.getChange1m(),
				year: price.getChange1y(),
				six_months: price.getChange6m(),
				five_years: price.getChange5y()
			},
			indexAssets: this.indexAllocationAdapter.adaptMany(price.getIndexAllocations())
		};
	}
}
